/*
  Приказ получен, а документ не заведён - конвейер и «Исполнение» (строка 304 реестра).

  Решение владельца 02.11.2026 (вариант «а»). «Получено» и «не предъявлено» с аудита
  26.10.2026 считаются по документам реестра исполнения, чтобы два экрана называли одно
  число. Счёт, переведённый в «приказ получен» сменой стадии без документа, в эти числа не
  попадает, и срок предъявления по нему идёт молча. Поэтому он назван отдельно: номером со
  ссылкой на карточку, где документ и заводится.

  Номеров - сколько прислал сервер (первые пять), число - по всем таким счетам.
*/

import { Fragment } from 'react'
import { Link } from 'react-router-dom'

import { accounts as accountsWord, grouped } from '../api/format.js'
import { Notice } from './Common.jsx'

export default function UndocumentedOrders({ count, accounts }) {
  if (!count) return null
  const rest = count - accounts.length
  return (
    <Notice kind="warn" wide>
      <div className="notice__what">
        Приказ получен, а документ не заведён: {accountsWord(count)} -{' '}
        {accounts.map((item, index) => (
          <Fragment key={item.account_id}>
            {index ? ', ' : ''}
            <Link to={`/accounts/${item.account_id}`}>№ {item.number}</Link>
          </Fragment>
        ))}
        {rest > 0 ? ` и ещё ${grouped(rest)}` : ''}.
      </div>
      <div className="notice__do">
        Такие приказы не попадают в «не предъявлено», и о сроке их предъявления никто не
        напомнит. Заведите приказ на карточке счёта - блок «Приказ получен».
      </div>
    </Notice>
  )
}
